import { Button, Chip, Grow, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useCart from "../utils/useCart";


export default function DpcCard({ item, disabled }){

    const navigate = useNavigate();

    const { cart, setCart } = useCart();

    const handleClick = () => {
        
        setCart({ session: null, product: item.id })

        navigate(`/dpc/success/${item.course}`)
    };

    const isSelected = cart.product === item.id;

    return (
        <Grow in={true}>

            <div className="apply-card" style={{ border: isSelected && 'solid 1px royalblue' }}>
                
                <img
                    src={item.picture}
                    alt={item.title}
                    className="apply-card-img"
                />

                <span className="apply-card-text">
                    {item.title}
                    <br/>
                    <small>{item.teachers}</small>
                </span>

                <Stack alignItems="center">
                    {item.variant === 'dpc' && <Chip label="Formation Continue" />}
                    {item.variant === 'dpc-pi' && <Chip label="Programme Intégré" color="primary" />}
                </Stack>

                {disabled ?
                    <div></div>
                    :
                    <Button 
                        sx={{height: 50}} 
                        onClick={handleClick}
                    >
                        Sélectionner
                    </Button>
                }
            </div>

        </Grow>
    );

}